import React, { memo } from 'react';
import styles from './HeaderCell.scss';
import { ColumnResizer } from './ColumnResizer';
import {
	isNullOrUndefined,
	isNumber,
	isObject,
	isString,
	useDeepMemoize,
} from '@chkp/mwc-common';

const useHeaderCellContext = ({ column, store, context }) => {
	const {
		key,
		label,
		locked = false,
		resizable = true,
		headerRenderer,
	} = column;
	const headerCellContext = { key, label, locked, resizable, store, context };

	try {
		const mod = headerRenderer?.(headerCellContext);
		if (React.isValidElement(mod) || isString(mod) || isNumber(mod)) {
			headerCellContext.content = mod;
		} else if (isObject(mod)) {
			Object.assign(headerCellContext, mod);
		}
	} catch (e) {
		console.error('HeaderCell renderer error: ', headerCellContext, e);
	}

	if (isNullOrUndefined(headerCellContext.content)) {
		headerCellContext.content = label;
	}

	return useDeepMemoize(headerCellContext);
};

let HeaderCell = (props) => {
	const { column, scrollXObservable } = props;
	const headerCellContext = useHeaderCellContext(props);
	const { content, key, locked, resizable } = headerCellContext;
	return (
		<div
			role={'columnheader'}
			data-column-key={key}
			className={styles.HeaderCell}
			style={{
				width: column.finalWidth,
				left: locked ? scrollXObservable.current : undefined,
				zIndex: locked ? 1 : undefined,
			}}
		>
			{content}
			{resizable && <ColumnResizer column={column} />}
		</div>
	);
};

HeaderCell = memo(HeaderCell);

export { HeaderCell };
